module.exports = __webpack_public_path__ + "static/media/1.48fed0f9.JPG";